import { Controller, useFormContext } from "react-hook-form";
import type { FC } from "react";
import type { ButtonSelectProps } from "../../ButtonSelect";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { ButtonSelect } from "../../ButtonSelect";

type Props = {
  name?: string;
} & ButtonSelectProps;

export const FormButtonSelect: FC<Props> = ({ name = "", ...props }) => {
  const { control } = useFormContext();
  return (
    <FormFieldWrapper name={name}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, ref } }) => {
          return <ButtonSelect ref={ref} value={value} onChange={onChange} {...props} />;
        }}
      />
    </FormFieldWrapper>
  );
};
